import React, { useState } from 'react';

import * as S from './styles';

import Menu from './components/Menu';
import ListLinks from './components/Link';
import ConsultScheduleButton from './components/ConsultScheduleButton';

const logo =
  'https://agendamento-images-nprd.telemedicinaeinstein.com.br/schedule-lib-assets/logo.svg';
const menu =
  'https://agendamento-images-nprd.telemedicinaeinstein.com.br/schedule-lib-assets/menu.svg';
// import { gtmEvent } from '../../utils/gtm';

type NavbarProps = {
  onOpenConsultSchedule: () => void;
};

const Navbar = ({ onOpenConsultSchedule }: NavbarProps) => {
  const [isOpen, setIsOpen] = useState(false);

  const handleConsultSchedule = () => {
    // gtmEvent({
    //   event: 'agendamento-einstein',
    //   categoria: 'consultar-agendamento',
    //   acao: 'step-1',
    //   rotulo: 'Consultar'
    // });
    onOpenConsultSchedule();
  };

  return (
    <S.Navbar>
      <S.Container>
        <S.WrapperMobile>
          <S.Menu onClick={() => setIsOpen(!isOpen)}>
            <img src={menu} alt="menu" />
          </S.Menu>
          <S.Logo>
            <img src={logo} alt="Logo" />
          </S.Logo>
          <S.None />
        </S.WrapperMobile>
        <S.WrapperDesktop>
          <S.LeftContent>
            <S.Logo>
              <img src={logo} alt="Logo" />
            </S.Logo>
            <ListLinks onCloseNav={() => setIsOpen(false)} />
          </S.LeftContent>
          <S.RightContent>
            <ConsultScheduleButton
              handleConsultSchedule={() => handleConsultSchedule()}
            />
          </S.RightContent>
        </S.WrapperDesktop>
      </S.Container>

      <Menu
        isOpen={isOpen}
        onClose={() => setIsOpen(false)}
        handleConsultSchedule={() => {
          setIsOpen(false);
          handleConsultSchedule();
        }}
      />
    </S.Navbar>
  );
};

export default Navbar;
